import React, { useState } from 'react';
import { Box, ClickAwayListener, InputAdornment, Popper, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useWindowSize } from '../../../utils/hooks';
import CustomCalendarPicker from '../CustomWeekPicker/CustomCalendarPicker';
import { calendarTypes } from '../../../utils/constants';

const textFieldStyles = (width) => ({
  width,
  backgroundColor: 'white',
  borderRadius: '10px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #D1D3D4',
    borderRadius: '10px'
  },
  color: '#283237',
  fontSize: '16px',
  fontWeight: '325',
  lineHeight: '19px',
  fieldset: {
    legend: {
      width: 'unset'
    }
  }
});

export default function CustomDayPicker({ date, changeHandler, sx, dayFormat }) {
  const size = useWindowSize();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const { t } = useTranslation();
  const [newDate, setDate] = useState(date);

  const handleCalendar = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handlePicker = (dt) => {
    setAnchorEl(null);
    setDate(dt);
    changeHandler(dt);
  };

  return (
    <>
      <TextField
        id="outlined-start-adornment"
        onClick={handleCalendar}
        value={dayjs(newDate).format(dayFormat)}
        sx={sx}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarMonthIcon />
            </InputAdornment>
          )
        }}
      />
      <Popper sx={{ zIndex: 1200 }} id={id} open={open} anchorEl={anchorEl}>
        <Box sx={{ border: 1, p: 0 }}>
          <CustomCalendarPicker
            userDate={date === t('dashboard.timesheets.filters.day') ? dayjs() : date}
            setUserDate={handlePicker}
            calendarType={calendarTypes.DAY}
          />
        </Box>
      </Popper>
    </>
  );
}
